import { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
} from "../../actions";
import axios from "../../axios";
import SendMessageComponent from "../message-requests/components/SendMessageComponent";

class index extends Component {
  state = {
    agencies: null,
    agenciesDropdownGet: null,
    agenciesDropdownSet: null,
    agencyListsDropdownSet: null,
    agencyListsDropdownGet: null,
  };
  constructor() {
    super();
  }
  componentDidMount() {
    this.getRelatedData();
  }
  async getRelatedData() {
    const { setLoading, user } = this.props;
    const { lang } = user;
    setLoading(true);
    //1
    let response = await axios.get("agencies/get-for-dropdown"),
      agenciesDropdownGet = [],
      agenciesDropdownSet = {};
    response.data.data.forEach((agency) => {
      agenciesDropdownGet.push({
        label: agency.name,
        value: agency.id,
      });
      agenciesDropdownSet["agency" + agency.id] = {
        label: agency.name,
        value: agency.id,
      };
    });
    await this.setState({
      agenciesDropdownGet: agenciesDropdownGet,
      agenciesDropdownSet: agenciesDropdownSet,
    });
    //2
    response = await axios.get("insurance-companies/get-for-dropdown");
    const companiesDropdownGet = [],
      companiesDropdownSet = {};
    response.data.data.forEach((company) => {
      companiesDropdownGet.push({
        label: company.name,
        value: company.id,
      });
      companiesDropdownSet["company" + company.id] = {
        label: company.name,
        value: company.id,
      };
    });
    companiesDropdownGet.unshift({
      label: window.sys_app_translate("All", lang),
      value: 0,
    });
    await this.setState({
      companiesDropdownGet: companiesDropdownGet,
      companiesDropdownSet: companiesDropdownSet,
    });
    //3
    await this.getAgenciesTree();
    //4
    response = await axios.get("agency-lists/get-for-dropdown");
    const agencyListsDropdownGet = [],
      agencyListsDropdownSet = {};
    response.data.data.forEach((agencyList) => {
      agencyListsDropdownGet.push({
        label: agencyList.name,
        value: agencyList.id,
      });
      agencyListsDropdownSet["agency-list" + agencyList.id] = {
        label: agencyList.name,
        value: agencyList.id,
      };
    });
    await this.setState({
      agencyListsDropdownGet: agencyListsDropdownGet,
      agencyListsDropdownSet: agencyListsDropdownSet,
    });
    setLoading(false);
  }
  async getAgenciesTree() {
    const { handleAppError } = this.props;
    const { agency_id } = this.props.user;
    try {
      const response = await axios.get("agencies/get-agencies-tree", {
        params: { rootagencyid: agency_id },
      });
      await this.setState({
        agencies: [response.data.data],
      });
    } catch (error) {
      handleAppError(error);
    }
  }
  isRelatedDataLoaded() {
    const { agencies, agenciesDropdownGet, companiesDropdownGet } = this.state;
    return agencies && agenciesDropdownGet && companiesDropdownGet;
  }
  render() {
    const { lang } = this.props.user;
    const { setLoading, showMessage, handleAppError, history } = this.props;
    const {
      agencies,
      companiesDropdownGet,
      companiesDropdownSet,
      agenciesDropdownGet,
      agenciesDropdownSet,
      agencyListsDropdownGet,
      agencyListsDropdownSet,
    } = this.state;
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{window.sys_app_translate("Messaging", lang)}</title>
        </Helmet>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {this.isRelatedDataLoaded() && (
                <SendMessageComponent
                  companiesDropdownGet={companiesDropdownGet}
                  companiesDropdownSet={companiesDropdownSet}
                  agenciesDropdownGet={agenciesDropdownGet}
                  agenciesDropdownSet={agenciesDropdownSet}
                  agencyListsDropdownGet={agencyListsDropdownGet}
                  agencyListsDropdownSet={agencyListsDropdownSet}
                  agencies={agencies}
                  showMessage={showMessage}
                  setLoading={setLoading}
                  handleAppError={handleAppError}
                  lang={lang}
                  historyObj={history}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { formErrors, currentRecord } = appReducer;
  return { user, formErrors, currentRecord };
};
export default connect(mapStateToProps, {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
})(index);
